import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { trackEvent } from '../lib/app-telemetry.js';

const getCurrentPath = () => {
  if (typeof window === 'undefined') return '';
  return `${window.location.pathname}${window.location.search}`;
};

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidMount() {
    window.__BLADE_CLEAR_BOOT_WATCHDOG__?.();
  }

  componentDidCatch(error, errorInfo) {
    window.__BLADE_CLEAR_BOOT_WATCHDOG__?.();

    trackEvent('app_render_error', {
      message: error?.message || String(error),
      name: error?.name || null,
      stack: error?.stack || null,
      component_stack: errorInfo?.componentStack || null,
      path: getCurrentPath(),
      user_agent: navigator.userAgent,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Alert severity="error" sx={{ width: '100%', maxWidth: 480 }}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                La app tuvo un problema al mostrar esta pantalla.
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                Recargá para volver a abrirla con la última versión disponible.
              </Typography>
            </Box>
            <Button variant="contained" onClick={this.handleReload}>
              Recargar app
            </Button>
          </Stack>
        </Alert>
      </Box>
    );
  }
}

export default AppErrorBoundary;
